import { apiGenders } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useGenders = (genderIds: number[] | undefined) => {
  return useQuery({
    queryKey: ['useGenders', genderIds],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted && genderIds) {
        const response = apiGenders.getGenders({ genderIds, language: 'EN' });
        return response;
      }
    },
    select: (data) => data?.filter((gender) => gender.label !== 'NO_GENDER'),
    refetchOnWindowFocus: false,
  });
};
